import { CLOSE_CONFIRM_DIALOG, TOGGLE_CONFIRM_DIALOG } from './constants';

export function toggleConfirmDialog(id) {
  return {
    type: TOGGLE_CONFIRM_DIALOG,
    payload: { id },
  };
}

export function closeConfirmDialog(id) {
  return {
    type: CLOSE_CONFIRM_DIALOG,
    payload: { id },
  };
}
